import globals from "globals";
import $ from "cash-dom";
import { ScrollTween2 as ScrollTween } from "Utilities";

const layout = (function () {
    /**
     * Initialize Horizontal Scroll instances
     */
    $(document).ready(function () {
        if ($(".horizontal-scroll").length) {
            if (globals.debug) console.log("layout-horizontal-scroll initialized");
            var horizontalScrolls = [];

            $(".horizontal-scroll")
                .each(function () {
                    var $this = $(this);
                    var height = $this.find(".horizontal-scroll__scrollport")[0].scrollWidth - window.innerHeight;

                    $this.height(height);
                })
                .on("wheel", function (_e) {
                    if (_e.deltaX != 0) {
                        _e.preventDefault();
                    }
                });

            $(".horizontal-scroll").each(function () {
                horizontalScrolls.push(
                    new ScrollTween({
                        element: $(this)[0],
                        from: "top-top",
                        to: "bottom-bottom",
                        callback: function (_n, _el) {
                            var scrollPort = $(_el).find(".horizontal-scroll__scrollport")[0];
                            console.log(scrollPort.scrollWidth);
                            var n = (scrollPort.scrollWidth - window.innerWidth) * _n;
                            if (!globals.isScrolling) scrollPort.scrollLeft = n;
                        },
                    })
                );
            });
        }

        $(window).on("resizeEnd", function () {
            $(".horizontal-scroll")
                .each(function () {
                    var $this = $(this);
                    var height = $this.find(".horizontal-scroll__scrollport")[0].scrollWidth - window.innerHeight;

                    $this.height(height);
                })
                .on("wheel", function (_e) {
                    if (_e.deltaX != 0) {
                        _e.preventDefault();
                    }
                });
        });
    });
})();

export default layout;
